import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WorkoutResult, WorkoutResultSetWrite } from 'types';
import { client } from 'utils/api-client';

export type LogWorkoutResultInput = {
  workoutSectionMovement: string;
  athleteKiloClass?: string | null;
  timeMinutes?: number | null;
  timeSeconds?: number | null;
  calories?: number | null;
  distanceValue?: string | null;
  reps?: number | null;
  rounds?: number | null;
  extraReps?: number | null;
  sets?: WorkoutResultSetWrite[];
  // Required by the backend on first log whenever the section offers ≥1 level.
  level?: 'scaled' | 'rx' | 'rx_plus' | null;
};

function useLogWorkoutResult(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<WorkoutResult>, AxiosError, LogWorkoutResultInput> {
  const queryClient = useQueryClient();
  return useMutation(
    (input: LogWorkoutResultInput) => client.post<WorkoutResult>('workout-results/log/', input),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workout-athlete-results', workoutId]);
        queryClient.invalidateQueries(['workout-leaderboard', workoutId]);
      },
    },
  );
}

export default useLogWorkoutResult;
